import { name, version } from '../package.json';

export default {
    actionRequired: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'If `true`, suppresses the ability to dismiss the modal with the `esc` key or by clicking the underlying page. An action in the modal must be used to dismiss.',
        },
    },
    title: {
        type: String,
        required: true,
        docs: {
            validation: '**Required**',
            description: 'Sets the title for the modal.',
        },
    },
    titleHidden: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, visibly hides the title.',
        },
    },
    visible: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'Used to toggle the visibility of the modal.',
            support: ['v-model'],
        },
    },
    width: {
        type: String,
        default: '900px',
        values: ['600px', '900px', '1200px'],
        validator(value) {
            return ['600px', '900px', '1200px'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `600px`, `900px`, `1200px`.',
            description: 'Sets the width of the modal.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
